import { useQuery } from "@tanstack/react-query";
import api from "utils/api";
import { projectKeys } from "./projectKeys";
import type {
  SidebarProject,
  UseSidebarProjectsArgs,
  UseSidebarProjectsResult,
} from "./types";

const EMPTY_PROJECTS: SidebarProject[] = [];

export const useSidebarProjects = ({
  organization,
  enabled,
}: UseSidebarProjectsArgs): UseSidebarProjectsResult => {
  const { data, isPending, error } = useQuery({
    queryKey: projectKeys.list({ organization }),
    queryFn: async (): Promise<SidebarProject[]> => {
      const data = await api.fetchProjects(
        organization ? { organization } : {},
      );
      return data.projects;
    },
    enabled,
  });

  return { projects: data ?? EMPTY_PROJECTS, isPending, error };
};
